const $ctaBanner = $('#js-cta-popup-banner');
const $bannerLinkButton = $('#js-cta-popup-banner-link');
const $bannerClose = $('#js-cta-popup-banner-close');
const $formOpenBtn = $('#js-cta-popup-show-form');
const $cookieBannerClose = $('.js-cookie-banner-close');

const $ctaForm = $('#js-cta-popup-form');
const $formClose = $('#js-cta-popup-form-close');
const $formSubmit = $('.js-cta-popup-submit');

const $cookieBanner = $('.js-cookie-banner');

let linkClicked = false;
let displayTiming = 'page_load';

const hideCtaPopupBanner = () => {
  // animate hiding the banner
  $ctaBanner
    .css('maxHeight', '0px')
    .css('opacity', 0);

  // actually hide the banner
  setTimeout(() => {
    $ctaBanner
      .css('maxHeight', '200px')
      .css('opacity', 1)
      .addClass('dn');
  }, 400);

  // set cookie to prevent the banner from showing again
  const ctaId = $ctaBanner.data('cta-id');
  const cookieKey = `cta-popup-${ctaId}`;
  const expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + 30);
  const cookieValue = `1; expires=${expirationDate.toUTCString()}'; path=/`;
  document.cookie = `${cookieKey}=${cookieValue}`;
};

const showCtaPopupBanner = () => {
  if ($ctaBanner.hasClass('dn') === false) return; // it's already showing

  // "show" the banner, but 0 height 0 opacity
  $ctaBanner
    .css('maxHeight', '0px')
    .css('opacity', 0)
    .removeClass('dn');

  // animate to reveal banner
  setTimeout(() => {
    $ctaBanner
      .css('maxHeight', '200px')
      .css('opacity', 1);
  }, 100);
  window.dataLayer.push({
    event: 'cta_popup_view',
    title: $ctaBanner.data('cta-title'),
    display_timing: displayTiming
  });
};

const clickCtaBannerClose = () => {
  hideCtaPopupBanner();

  if (linkClicked) return;
  // don't send the event if the banner link was clicked
  window.dataLayer.push({
    event: 'cta_popup_closed',
    type: 'banner',
    title: $ctaBanner.data('cta-title'),
    display_timing: displayTiming
  });
};

const showCtaPopupForm = () => {
  hideCtaPopupBanner();
  $ctaForm.removeClass('dn');

  window.dataLayer.push({
    event: 'cta_popup_click',
    type: 'form_button',
    title: $ctaBanner.data('cta-title'),
    display_timing: displayTiming
  });
};

const hideCtaPopupForm = () => {
  $ctaForm.addClass('dn');

  // don't send the event if the form was already submitted
  if ($formSubmit.length) {
    window.dataLayer.push({
      event: 'cta_popup_closed',
      type: 'form',
      title: $ctaBanner.data('cta-title'),
      display_timing: displayTiming
    });
  }
};

const clickCtaPopupLink = () => {
  linkClicked = true;
  window.dataLayer.push({
    event: 'cta_popup_click',
    type: 'link_button',
    title: $ctaBanner.data('cta-title'),
    button_url: $bannerLinkButton.attr('href'),
    display_timing: displayTiming
  });
};

const shouldDisplayBanner = () => {
  if (!$ctaBanner.length) return false;
  if (!$cookieBanner.hasClass('dn')) return false;

  // check cookies banner isn't showing
  // if (!$('.consent-confirmation-banner').hasClass('dn')) return false;
  // if (window.localStorage.getItem('cookie_consent') !== 'true') return false;

  // Display the cta popup banner if the user has specified cta_popup as a param in the URL - This
  // makes it easy to test the banner and the form
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('cta_popup')) return true;

  const ctaId = $ctaBanner.data('cta-id');
  const cookieKey = `cta-popup-${ctaId}`;

  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.indexOf(cookieKey) === 0) {
      return false;
    }
  }

  return true;
};

const allowCtaPopupDisplay = () => {
  // wait 3 seconds before possibly showing the cta popup banner
  setTimeout(() => {
    // wait 10 seconds more - show banner if allowed
    setTimeout(() => {
      if (shouldDisplayBanner()) {
        displayTiming = 'delay_after_cookie_banner';
        showCtaPopupBanner();
      }
    }, 10000);

    // OR show after check scroll depth is over 50%
    $(window).on('scroll', () => {
      const scrollTop = $(window).scrollTop();
      const docHeight = $(document).height();
      const winHeight = $(window).height();
      const scrollPercent = (scrollTop) / (docHeight - winHeight);
      const scrollPercentRounded = Math.round(scrollPercent * 100);

      if (scrollPercentRounded > 50) {
        if (shouldDisplayBanner()) {
          displayTiming = 'scroll_after_cookie_banner';
          showCtaPopupBanner();
        }
        // remove the scroll event listener
        $(window).off('scroll');
      }
    });
  }, 3000);
};

$(() => {
  $bannerClose.on('click', clickCtaBannerClose);
  $bannerLinkButton.on('click', clickCtaPopupLink);
  $formOpenBtn.on('click', showCtaPopupForm);
  $formClose.on('click', hideCtaPopupForm);
  $cookieBannerClose.on('click', allowCtaPopupDisplay);

  if (shouldDisplayBanner()) {
    showCtaPopupBanner();
  }
});

$('body').on('click', (e) => {
  if (e.target.classList.contains('js-cta-modal')) hideCtaPopupForm();
});
